import { useLocation } from "react-router";
import { useScreenSize } from "../contexts/screenSizeContext";
import { useProfileModal } from "../contexts/profileModalContext";
import Menu from "../components/menu";
import ConnectionStatus from "../components/connectionStatus/connectionStatus";
import BottomNav from "../components/bottomNav/bottomNav";
import ProfileModal from "../components/ProfileModal";
import { Outlet } from "react-router";
import { Col, Row } from "react-bootstrap";
import WheelSnapshotObserver from "../components/reflection/WheelSnapshotObserver";
import SnapshotMiddleware from "../components/plan/SnapshotMiddleware";


export default function WheelLayout() {
    const screenSize = useScreenSize();
    const isMobile = screenSize === "MOBILE";
    const location = useLocation();
    const wheelId = location.pathname.split('/')[1];

    const { showProfile, handleProfileHide } = useProfileModal();

    return (
        <div className="app-background">
            <div className="app-container">
                {/* Наблюдатель за изменениями для автосохранения снимков колеса */}
                <WheelSnapshotObserver />
                {/* Периодический снепшот эффективности ролей */}
                <SnapshotMiddleware />
                
                {screenSize !== "MOBILE" && (
                    <div className="app-header-spacer">
                        <Menu />
                    </div>
                )}
                {isMobile && <>
                    <Row>
                        <Col className="d-flex justify-content-center mb-4" xs={12}>
                            <img src="/logo192.png" width={32} height={32} alt="Артефакты" />
                        </Col>
                    </Row>
                    <ConnectionStatus />
                </>}
                <div className="main-container" style={{ paddingBottom: screenSize === "MOBILE" ? "80px" : "0" }}>
                    <Outlet />
                </div>
                <BottomNav />
                {wheelId && <ProfileModal show={showProfile} onHide={handleProfileHide} />}
            </div>
        </div>
    );
};
